export interface SubmitToSandboxSamplesFormWebComponentSchema {
  // all the data needed for rendering
}

export const MAXIMUM_ALLOWED_SAMPLES_COUNT = 5;
export const MAXIMUM_PATH_LENGTH = 1024;

export enum OperatingSystem {
  // Constants as found in ProtectedEntities
  Windows = 3,
  Unix = 4,
  Mac = 6,
}
